// extracted by mini-css-extract-plugin
export default {"inProgressDot":"inProgressDot--ykFUX"};